<template>
    <div>
        <h1 class="mb-2">{{ project.project_name }}</h1>
        <h4 class="font-weight-normal" 
            v-if="project.unit_lowest && project.unit_highest"
        ><i class="font-weight-bold">from</i> RM{{ project.unit_lowest.unit_price | moneyFormatter }} <i class="font-weight-bold">to</i> RM{{ project.unit_highest.unit_price | moneyFormatter }}</h4>
        <h4 class="font-weight-normal"><i class="font-weight-bold">by</i> {{project.project_developer }}</h4>
        <h4 class="font-weight-normal"><i class="font-weight-bold">at</i> 
            {{ project.project_location }} <i class="fa fa-map-marked-alt"></i></h4>
    </div>    
</template>

<script>
export default {
    props: ['project']
}
</script>

